import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=05173518&scoped=true"
import script from "./WordCloud.vue?vue&type=script&lang=js"
export * from "./WordCloud.vue?vue&type=script&lang=js"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=05173518&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05173518",
  null
  
)

export default component.exports